import React, { Component } from 'react'
import { Trans } from '@lingui/react'
import { connect } from 'react-redux'
import LoadingIndicator from './LoadingIndicator.js'
import CenterBox from './CenterBox.js'

class FetchSurveyPage extends Component {
  render() {
    const { surveyState } = this.props

    if (surveyState === 'fetching')
      return (
        <LoadingIndicator>
          <Trans>One moment, please...</Trans>
        </LoadingIndicator>
      )

    const Message =
      surveyState === 'invalid-token' ? (
        <Trans>This link has expired.</Trans>
      ) : (
        <Trans>
          An error has occurred. Please try again later and contact
          support@remente.com if the problem persists.
        </Trans>
      )

    return <CenterBox>{Message}</CenterBox>
  }
}

const mapStateToProps = ({ surveyState }) => ({
  surveyState,
})

export default connect(mapStateToProps)(FetchSurveyPage)



// WEBPACK FOOTER //
// ./src/components/FetchSurveyPage.js